import { Config } from "../core/config/config";
import { Grid } from "../core/components/grid";
import { Dialog, DialogProps } from "../core/components/dialog";
import { ToolBar } from "../core/components/toolBar";
import { Helper } from "../core/util/helper";
import { CreateMultipleAssignmentsContext, ContainerInfo } from "./createMultipleAssignments";
import { BaseComponentProps } from "../core/components/baseComponentProps";
import { KeyValuePair } from "../commonInterfaces";
import React from "react";

export default class ContainerSelection extends React.Component<GroupSelectionProps, GroupSelectionState> {
    private dialogRef: ContainerSelectionDialog;
    private gridOptions: kendo.ui.GridOptions;
    private id: string;

    constructor(props: GroupSelectionProps) {
        super(props);
        this.initApp();
        this.id = kendo.guid();
        this.state = {
            gridData: [],
            selected: null
        }
    }
    
    //Als callback für den setState aufruf
    private onDataChange = () => {
        const values: ContainerInfo[] = this.state.gridData.map((item) => {
            return {
                Amount: item.Amount,
                GroupId: item.Key
            };
        })
        this.props.onChange(this.props.field, values);
    }

    private initApp = () => {
        this.gridOptions = {
            dataSource: {
                schema: {
                    model: {
                        id: "Id",
                        fields: {
                            Value: { editable: false },
                            Amount: {
                                editable: true,
                                type: "number",
                                validation: { required: true, min: 1 }
                            }
                        }
                    }
                }
            },
            sortable: true,
            pageable: true,
            groupable: false,
            filterable: false,
            selectable: true,
            resizable: true,
            scrollable: true,
            editable: true,
            save: (e: kendo.ui.GridSaveEvent) => {
                let item = (e.model) as any;
                item.Amount = e.values["Amount"];
                this.onAmountChange(item)
            },
            columns: [
                {
                    field: "Value",
                    title: this.props.context.translations["GeoMap.Container"]
                },
                {
                    field: "Amount",
                    title: this.props.context.translations["Field.Material.anzahl"],
                    editable: () => {
                        return true;
                    },
                    format: "{0:d}"
                }
            ]
        };
    }

    private onAmountChange = (item: any) => {
        const data = this.state.gridData;
        const index = data.findIndex(f => f.Key == item.Key);
        data[index].Amount = item.Amount;
        this.setState({ gridData: data }, this.onDataChange)
    }

    private createToolBar = () => {
        let customButtons = [
            { caption: Config.translations.add, enabled: true, iconClass: "k-i-plus", id: "add" },
            { caption: Config.translations.delete, enabled: Helper.hasValue(this.state.selected), iconClass: "k-i-close", id: "remove" }
        ];
        return (
            <>
                <ToolBar customButtons={customButtons} handleCustomButtonClick={this.handleClickCustomButton} />
            </>
        );
    }

    private createGrid = () => {

        return (
            <div className="flex-container">
                <Grid
                    data={this.state.gridData}
                    options={this.gridOptions}
                    id="containerSelectionGrid"
                    onSelectionChanged={this.onSelectionChange}
                />
            </div>
        );
    }

    private onSelectionChange = (item: GroupSelectionValue) => {
        if (Helper.hasValue(item))
            this.setState({ selected: item }, this.onDataChange)
    }

    private createReplacementText = () => {
        return (
            <div style={{ display: "grid" }}>
                <div style={{ display: "flex", justifyContent: "center", gridArea: "1/1/1/1" }}>
                    <i className="fal fa-user-friends fa-10x" style={{ opacity: 0.1 }}></i>
                </div>
                <div style={{ textAlign: "center", gridArea: "1/1/1/1", paddingTop: "40px" }}>
                    <label style={{ fontSize: "15px" }}>
                        {this.props.context.translations["Einsatz.MultipleCreation.NoContainers"]}
                    </label>
                </div>
            </div>
        );
    }

    private handleClickCustomButton = (id: string) => {
        switch (id) {
            case "add":
                const dataSource = this.props.dataSource.filter(f1 => this.state.gridData.findIndex(f2 => f2.Key == f1.Key) === -1);
                this.dialogRef.openDialog(dataSource);
                break;
            case "remove":
                let data = this.state.gridData;
                data = data.filter(f => f.Key != this.state.selected.Key)
                this.setState({ gridData: data }, this.onDataChange)
                break;
        }
    }

    private createDialog = () => {
        return <>
            <ContainerSelectionDialog
                dataSource={this.props.dataSource}
                onOk={this.onOk}
                ref={(ref) => { this.dialogRef = ref }}
            />
        </>
    }

    private onOk = (grNrs: number[]) => {
        const data = this.state.gridData;
        grNrs.forEach((grNr) => {
            const item = this.props.dataSource.find(f => f.Key == grNr);
            data.push({
                Amount: 1,
                Key: grNr,
                Value: item.Value
            })
        })
        this.setState({ gridData: data }, this.onDataChange)
    }

    render() {
        const dialog = this.createDialog();
        const grid = this.state.gridData.length > 0 ? this.createGrid() : this.createReplacementText();
        const toolBar = !this.props.disabled ? this.createToolBar() : null;
        return (
            <div id={this.id}>
                {toolBar}
                {grid}
                {dialog}
            </div>
        );
    }
}

interface GroupSelectionProps extends BaseComponentProps {
    dataSource: KeyValuePair<number, string>[];
    value: ContainerInfo[];
    context: CreateMultipleAssignmentsContext;
}

interface GroupSelectionState {
    gridData: GroupSelectionValue[];
    selected: GroupSelectionValue;
}

interface GroupSelectionValue extends KeyValuePair<number, string> {
    Amount: number;
}

class ContainerSelectionDialog extends React.Component<GroupSelectionDialogProps, GroupSelectionDialogState>{

    private dialogProps: DialogProps = {
        title: Helper.getTranslation("GeoMap.Container"),
        actions: [
            {
                label: Config.translations.cancel,
                action: () => {
                    this.setState({ dialogOpen: false })

                }
            },
            {
                label: Config.translations.ok,
                action: () => {
                    this.setState({ dialogOpen: false }, () => {
                        this.props.onOk(this.state.values)
                    })
                },
                primary: true
            }
        ],
        width: 500
    };

    constructor(props: GroupSelectionDialogProps) {
        super(props)
        this.state = {
            dataSource: JSON.parse(JSON.stringify(props.dataSource)),
            dialogOpen: false,
            values: []
        }
    }

    openDialog = (dataSource: KeyValuePair<number, string>[]) => {
        this.setState({ dataSource: JSON.parse(JSON.stringify(dataSource)), dialogOpen: true, values: [] })
    }

    private createDialog = () => {
        return (
            <>
                <Dialog {...this.dialogProps} open={true}>
                    {this.createField()}
                </Dialog>
            </>
        );
    }

    private createField = () => {
        const props: MultiselectProps = {
            values: this.state.values,
            dataSource: this.state.dataSource,
            onChange: (values: number[]) => {
                this.setState({ values: values })
            }
        }
        return (
            <>
                <Multiselect {...props} />
            </>
        );
    }

    render() {
        return this.state.dialogOpen ? this.createDialog() : null;
    }
}

interface GroupSelectionDialogProps {
    dataSource: KeyValuePair<number, string>[];
    onOk: (grNrs: number[]) => void
}

interface GroupSelectionDialogState {
    dataSource: KeyValuePair<number, string>[];
    dialogOpen: boolean;
    values: number[];
}

class Multiselect extends React.Component<MultiselectProps, MultiselectState>{
    private multiSelectRef: any;
    private multiSelect: kendo.ui.MultiSelect;

    constructor(props: MultiselectProps) {
        super(props);
        this.state = {
            dataSource: JSON.parse(JSON.stringify(props.dataSource))
        }
    }

    private build = () => {
        this.multiSelect = $(this.multiSelectRef).kendoMultiSelect({
            value: this.props.values,
            enable: true,
            dataSource: this.state.dataSource,
            itemTemplate: "<div>#=data.Value#</div>",
            tagTemplate: "<div>#=data.Value#</div>",
            clearButton: true,
            change: (ev) => {
                const keys = ev.sender.value().map((x) => { return x.Key });
                this.props.onChange(keys)
            }
        }).data("kendoMultiSelect");
    }

    componentDidUpdate() {
        if (JSON.stringify(this.state.dataSource) != JSON.stringify(this.props.dataSource)) {
            this.setState({ dataSource: this.props.dataSource }, () => {
                this.multiSelect.setDataSource(this.state.dataSource as any)
            });
        }
    }

    componentDidMount() {
        this.build();
    }

    render() {
        let style: React.CSSProperties = {
            width: "100%"
        };
        return (
            <div>
                <select ref={(r) => this.multiSelectRef = r} style={style} />
            </div>
        );
    }
}

interface MultiselectProps {
    dataSource: KeyValuePair<number, string>[];
    onChange: (values: number[]) => void;
    values: number[]
} 

interface MultiselectState {
    dataSource: KeyValuePair<number, string>[];
}